/* 
To use for delaying dom-altering commands on user action, improving perceived 
performance.
*/
import { getConfig } from 'config';

const delay = getConfig().isFastDOMRenderer ? 0 : 30;

export default fn => setTimeout(fn, delay);
